import CollapsePanel from 'antd/lib/collapse/CollapsePanel';
import React from 'react';
import Collapse from '../../common/components/dataEntry/components/Collapse';

const Step4: React.FC = () => {
  return (
    <Collapse accordion className="mt-32 mb-32 step4">
      <CollapsePanel header="What happens if I opt-in?" key="1">
        <p>
          If you opt-in you will need to make sure you have a qualified health
          plan for your ICHRA benefit. Once your benefit starts, you’ll be able
          to get reimbursed for your premiums! Not sure what to do? You can
          change your mind until your benefit start date. Once your benefit has
          officially started, you cannot change your mind until your benefit
          renews.
        </p>
      </CollapsePanel>
      <CollapsePanel header="What happens if I opt-out?" key="2">
        <p>
          If you opt-out, you can still change your mind until your benefit
          start date. Once your benefit has officially started, you cannot
          change your mind until your benefit renews next year unless you have a
          qualifying event, such as loss in coverage.
        </p>
      </CollapsePanel>
    </Collapse>
  );
};
export default Step4;
